/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemSpecialityGroupViewModel } from '../../models/system-speciality-group-view-model';

export interface ApiSystemSpecialityGroupGet$Params {
  systemOrgFhirId?: string;
}

export function apiSystemSpecialityGroupGet(http: HttpClient, rootUrl: string, params?: ApiSystemSpecialityGroupGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SystemSpecialityGroupViewModel>>> {
  const rb = new RequestBuilder(rootUrl, apiSystemSpecialityGroupGet.PATH, 'get');
  if (params) {
    rb.query('systemOrgFhirId', params.systemOrgFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<SystemSpecialityGroupViewModel>>;
    })
  );
}

apiSystemSpecialityGroupGet.PATH = '/api/SystemSpecialityGroup';
